<template>
  <div class="toast-container" aria-live="polite">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="toast-item"
        :class="`toast-${toast.type}`"
        role="status"
      >
        <span class="toast-message">{{ toast.message }}</span>
        <button
          class="toast-close"
          aria-label="Dismiss notification"
          @click="dismiss(toast.id)"
        >
          ✕
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '../../composables/useToast';

const { toasts, dismiss } = useToast();
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: var(--space-4);
  right: var(--space-4);
  z-index: 3000;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  pointer-events: none;
}

.toast-item {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  color: #fff;
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  pointer-events: auto;
  min-width: 250px;
  max-width: 400px;
}

.toast-success {
  background-color: var(--color-success);
}

.toast-error {
  background-color: var(--color-danger);
}

.toast-message {
  flex: 1;
  word-break: break-word;
}

.toast-close {
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: var(--text-sm);
  padding: var(--space-1);
  line-height: 1;
  opacity: 0.8;
  flex-shrink: 0;
}

.toast-close:hover {
  opacity: 1;
}

/* Slide-from-right enter animation */
.toast-enter-active {
  transition: all 0.3s ease-out;
}

/* Fade-out leave animation */
.toast-leave-active {
  transition: opacity 0.3s ease-in;
}

.toast-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.toast-leave-to {
  opacity: 0;
}

/* Smooth repositioning when items are removed */
.toast-move {
  transition: transform 0.3s ease;
}
</style>
